
export default function isSquadUrlLocationUtil () {
  return window.location.pathname.startsWith('/pages/squad')
}
